exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\n  height: 100%; }\n  .App .content-container {\n    display: flex;\n    margin-top: 80px; }\n  .App .ant-badge-status-dot {\n    height: 10px;\n    width: 10px; }\n  .App .ant-table-row-cell-break-word {\n    text-align: center; }\n", ""]);

